export const serializeStiffening = (data: StiffeningProposal) => {
  if (!data) return []

  return data.map(({ localId, ...item }) => item)
}
